export default "__VITE_ASSET__bb3a4538__"